import ApiService from "../../../common/api.service";
import { router } from "../../../router";
import { Notification } from "element-ui";
export async function login({ commit }, data) {
  try {
    ApiService.init("heroku");
    commit("LOGIN_REQUEST");
    const _response = await ApiService.post("/v1/auth/login", data);
    commit("LOGIN_SUCCESS", { results: _response });
    Notification.success({
      title: "Success",
      dangerouslyUseHTMLString: true,
      message: "Anda berhasil login"
    });
    router.push("/");
  } catch (error) {
    commit("LOGIN_ERROR", { result: error.message });
    let messageError = "";
    if (error.response.data.status == 401) {
      messageError = error.response.data.errors.message;
    } else {
      error.response.data.errors.stackTrace.map(item => {
        messageError += `<li>${item.msg}</li>`;
      });
    }
    Notification.error({
      title: "Error",
      dangerouslyUseHTMLString: true,
      message: `<ul>${messageError}</ul>`
    });
  }
}

export async function logout({ commit }) {
  try {
    ApiService.init("heroku");
    commit("LOGOUT_REQUEST");
    localStorage.removeItem("user");
    commit("LOGOUT_SUCCESS");
    router.push("/login");
  } catch (error) {
    commit("LOGOUT_ERROR", { result: error.message });
  }
}
